import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function FormValidation({ errorType, showError }) {
  const { t } = useTranslation();

  if (!showError || !errorType) return null;

  return (
    <div className="mt-2 text-xs text-red-500">
      {errorType === "duplicate"
        ? t("duplicatePhoneError")
        : t("incompleteFormValidation")}
    </div>
  );
}

export default FormValidation;
